import script from "./passageVue.vue?vue&type=script&setup=true&lang=js"
export * from "./passageVue.vue?vue&type=script&setup=true&lang=js"

import "./passageVue.vue?vue&type=style&index=0&id=6d801fdf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d801fdf"]])

export default __exports__